<template>
  <div class="people-18-container">
    <img
      src="../new-assets/leftright.png"
      class="tip-icon"
      alt=""
      v-if="isShowTip"
    />
    <div class="swiper-container">
      <div
        class="swiper-cell"
        v-for="(s, i) in imagesList"
        :key="i"
        :style="{
          left: `${translateX}px`,
          transition: isMoving ? 'unset' : 'all 0.4s',
        }"
      >
        <div
          class="swiper-cell-image-container"
          :style="{ 'background-image': `url('${s}')` }"
        >
          <img :src="giftList[0]" alt="" class="gift-img" @click="_next(i)" />
        </div>
      </div>
    </div>

    <div
      class="active-swiper-container"
      @mousedown="onTapStart"
      @mouseup="onTapEnd"
      @mousemove="onTapMove"
    ></div>

    <div class="control-bar">
      <img
        src="https://jcdn.xhby.net/project/xiaokang/assets/people18/car.png"
        class="car"
        alt=""
        :style="{ left: `${(90 * activeIndex) / 18}%` }"
      />
      <div class="icon-container">
        <img
          src="https://jcdn.xhby.net/project/xiaokang/assets/people18/hear-icon.png"
          alt=""
        />
      </div>
      <div class="player-container">
        <img
          src="https://jcdn.xhby.net/project/xiaokang/assets/people18/play.png"
          alt=""
          class="play-pause-icon"
          @click="() => play()"
          v-if="!playing"
        />
        <img
          src="https://jcdn.xhby.net/project/xiaokang/assets/people18/pause.png"
          alt=""
          class="play-pause-icon"
          @click="stop"
          v-else
        />
        <div class="player-inner">
          <div class="names">
            {{ readerList[activeIndex] }}
          </div>
          <div class="bar-container">
            <div class="real-bar-container">
              <div class="bg-bar">
                <div class="front-bar" :style="{ width: `${playingPercent}%` }">
                  <div class="ball"></div>
                </div>
              </div>
            </div>
            <div class="times">00:{{ audioTotalTime }}</div>
          </div>
        </div>
      </div>
      <div class="cells-container" ref="cellsContainer">
        <template v-for="i in 18">
          <div
            class="cell"
            :key="i"
            v-if="activeIndex !== i - 1"
            @click="onSelectAudio(i - 1)"
          >
            {{ i }}
          </div>
          <div class="cell cell-playing" :key="i" v-else>
            <img
              src="https://jcdn.xhby.net/project/xiaokang/assets/people18/playing.png"
              alt=""
            />
          </div>
        </template>
      </div>

      <audio src="" ref="audio" @timeupdate="onPlaying"></audio>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    next: Function,
  },
  data() {
    return {
      // imagesList: [
      //   "https://jcdn.xhby.net/project/xiaokang/assets/people18/people (1).png",
      //   "https://jcdn.xhby.net/project/xiaokang/assets/people18/people (2).png",
      //   "https://jcdn.xhby.net/project/xiaokang/assets/people18/people (3).png",
      //   "https://jcdn.xhby.net/project/xiaokang/assets/people18/people (4).png",
      //   "https://jcdn.xhby.net/project/xiaokang/assets/people18/people (5).png",
      //   "https://jcdn.xhby.net/project/xiaokang/assets/people18/people (6).png",
      //   "https://jcdn.xhby.net/project/xiaokang/assets/people18/people (7).png",
      //   "https://jcdn.xhby.net/project/xiaokang/assets/people18/people (8).png",
      //   "https://jcdn.xhby.net/project/xiaokang/assets/people18/people (9).png",
      //   "https://jcdn.xhby.net/project/xiaokang/assets/people18/people (10).png",
      //   "https://jcdn.xhby.net/project/xiaokang/assets/people18/people (11).png",
      //   "https://jcdn.xhby.net/project/xiaokang/assets/people18/people (12).png",
      //   "https://jcdn.xhby.net/project/xiaokang/assets/people18/people (13).png",
      //   "https://jcdn.xhby.net/project/xiaokang/assets/people18/people (14).png",
      //   "https://jcdn.xhby.net/project/xiaokang/assets/people18/people (15).png",
      //   "https://jcdn.xhby.net/project/xiaokang/assets/people18/people (16).png",
      //   "https://jcdn.xhby.net/project/xiaokang/assets/people18/people (17).png",
      //   "https://jcdn.xhby.net/project/xiaokang/assets/people18/people (18).png",
      // ],
      imagesList: [
        require("../new-new-assets/people18/01.jpg"),
        require("../new-new-assets/people18/02.jpg"),
        require("../new-new-assets/people18/03.jpg"),
        require("../new-new-assets/people18/04.jpg"),
        require("../new-new-assets/people18/05.jpg"),
        require("../new-new-assets/people18/06.jpg"),
        require("../new-new-assets/people18/07.jpg"),
        require("../new-new-assets/people18/08.jpg"),
        require("../new-new-assets/people18/09.jpg"),
        require("../new-new-assets/people18/10.jpg"),
        require("../new-new-assets/people18/11.jpg"),
        require("../new-new-assets/people18/12.jpg"),
        require("../new-new-assets/people18/13.jpg"),
        require("../new-new-assets/people18/14.jpg"),
        require("../new-new-assets/people18/15.jpg"),
        require("../new-new-assets/people18/16.jpg"),
        require("../new-new-assets/people18/17.jpg"),
        require("../new-new-assets/people18/18.jpg"),
      ],
      audioList: [
        "https://jcdn.xhby.net/project/xiaokang/assets/audio/short/01.mp3",
        "https://jcdn.xhby.net/project/xiaokang/assets/audio/short/02.mp3",
        "https://jcdn.xhby.net/project/xiaokang/assets/audio/short/03.mp3",
        "https://jcdn.xhby.net/project/xiaokang/assets/audio/short/04.mp3",
        "https://jcdn.xhby.net/project/xiaokang/assets/audio/short/05.mp3",
        "https://jcdn.xhby.net/project/xiaokang/assets/audio/short/06.mp3",
        "https://jcdn.xhby.net/project/xiaokang/assets/audio/short/07.mp3",
        "https://jcdn.xhby.net/project/xiaokang/assets/audio/short/08.mp3",
        "https://jcdn.xhby.net/project/xiaokang/assets/audio/short/09.mp3",
        "https://jcdn.xhby.net/project/xiaokang/assets/audio/short/10.mp3",
        "https://jcdn.xhby.net/project/xiaokang/assets/audio/short/11.mp3",
        "https://jcdn.xhby.net/project/xiaokang/assets/audio/short/12.mp3",
        "https://jcdn.xhby.net/project/xiaokang/assets/audio/short/13.mp3",
        "https://jcdn.xhby.net/project/xiaokang/assets/audio/short/14.mp3",
        "https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/xiaokang/assets/audio/short/qinghai.mp3",
        "https://jcdn.xhby.net/project/xiaokang/assets/audio/short/16.mp3",
        "https://jcdn.xhby.net/project/xiaokang/assets/audio/short/17.mp3",
        "https://jcdn.xhby.net/project/xiaokang/assets/audio/short/18.mp3",
      ],
      giftList: [require("../new-assets/jian.png")],
      readerList: [
        "讲述人：季金华",
        "讲述人：黄卫东",
        "讲述人：王祥元",
        "讲述人：李芳",
        "讲述人：马连龙",
        "讲述人：李坤宝",
        "讲述人：李维月",
        "讲述人：陆宝华",
        "讲述人：朱立雄",
        "讲述人：万后宏",
        "讲述人：李平",
        "讲述人：王侠",
        "讲述人：王小乔",
        "讲述人：李旭瑛",
        "讲述人：李强",
        "讲述人：范维维",
        "讲述人：袁良萍",
        "讲述人：祁男",
      ],

      activeIndex: 0,
      translateX: 0,

      playing: false,
      audioTotalTime: "00",
      playingPercent: 0,

      touchEventOldY: 0,
      translateXBeforeMove: 0,
      isMoving: false,

      isShowTip: true,
    };
  },
  watch: {
    activeIndex() {
      this.$store.commit("changeActiveIndexPub", this.activeIndex);
    },
  },
  mounted() {
    this.activeIndex = this.$store.state.activeIndexPub;
    this.onSelectAudio(this.activeIndex);
    setTimeout(() => {
      this.isShowTip = false;
    }, 3000);
  },
  methods: {
    onSelectAudio(i) {
      if (i < 0 || i > 17) return;
      this.activeIndex = i;
      this.translateX = this.activeIndex * -1 * window.innerWidth;
      this.play(this.audioList[i]);
    },

    play(src) {
      const audioInstance = this.$refs.audio;
      if (src) {
        audioInstance.src = src;
      }
      audioInstance.play();
      this.playing = true;
    },

    stop() {
      const audioInstance = this.$refs.audio;
      audioInstance.pause();
      this.playing = false;
    },

    onPlaying(a) {
      const audioInstance = this.$refs.audio;
      if (!audioInstance) return;
      const dur = audioInstance.duration;
      const now = audioInstance.currentTime;
      if (!dur || !now) return;

      this.audioTotalTime = Math.floor(dur).toString();
      this.playingPercent = (100 * now) / dur;
    },

    onTapStart(e) {
      this.touchEventOldY = e.clientX;
      this.isMoving = true;
      this.translateXBeforeMove = this.translateX;
    },

    onTapEnd() {
      this.isMoving = false;
      // 移动了的距离
      const distance = this.translateXBeforeMove - this.translateX;
      if (
        (this.activeIndex === 0 && distance < 0) ||
        (this.activeIndex === 17 && distance > 0)
      ) {
        // 第一页往左 || 最后一页往右
        this.translateX = this.activeIndex * -1 * window.innerWidth;
      } else if (Math.abs(distance) < window.innerWidth / 6) {
        // 回弹
        this.translateX = this.activeIndex * -1 * window.innerWidth;
      } else if (distance < 0) {
        this.onSelectAudio(this.activeIndex - 1);
      } else {
        this.onSelectAudio(this.activeIndex + 1);
      }

      let container = this.$refs.cellsContainer;
      container.scrollLeft =
        // 底栏搞15vh
        this.activeIndex * (0.15 * 0.7) * window.innerHeight;
    },

    onTapMove(e) {
      e.preventDefault();
      if (!this.isMoving) return;
      let moveYDistance = e.clientX - this.touchEventOldY;
      this.touchEventOldY = e.clientX;
      this.translateX += moveYDistance;
    },

    _next(i) {
      this.next && this.next();
    },
  },
};
</script>

<style lang="less" scoped>
@control-bar-width: 15vh;

.people-18-container {
  width: 100vw;
  height: 100vh;
  overflow: hidden;

  .swiper-container {
    width: 100%;
    height: 100%;
    display: flex;
    overflow: hidden;

    .swiper-cell {
      width: 100vw;
      height: 100vh;
      flex-shrink: 0;
      position: relative;

      .swiper-cell-image-container {
        width: 100%;
        height: 100%;
        background-size: cover;
        background-position: 50% 50%;
        position: relative;

        .gift-img {
          width: 20vh;
          position: absolute;
          right: 10vh;
          top: 20vh;
          animation: floatMe 5s infinite linear;
          cursor: pointer;
          z-index: 200;
        }
      }
    }
  }

  .active-swiper-container {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    height: calc(100vh - @control-bar-width - 10px);
    // pointer-events: none;
    z-index: 100;
  }

  .control-bar {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: @control-bar-width;
    background: #c23439;
    padding: 2px 0;
    display: flex;

    .car {
      position: absolute;
      bottom: calc(100%);
      width: 10vw;
      transition: all 0.4s;
    }

    .icon-container {
      width: @control-bar-width;
      height: 100%;
      border-right: 1px solid white;
      display: flex;
      align-items: center;

      img {
        width: 80%;
      }
    }

    .player-container {
      width: @control-bar-width * 3.4;
      display: flex;
      align-items: center;
      padding-left: 20px;

      .play-pause-icon {
        width: @control-bar-width * 0.3;
        cursor: pointer;
      }

      .player-inner {
        flex: 1;
        height: 100%;
        margin-left: 20px;
        display: flex;
        flex-direction: column;

        .names {
          height: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 22px;
          font-weight: 300;
        }

        .bar-container {
          flex: 1;
          display: flex;
          align-items: center;
          padding: 0 10px;

          .real-bar-container {
            flex: 1;
            height: 100%;
            display: flex;
            align-items: center;

            .bg-bar {
              height: 2px;
              width: 100%;
              background: #fa6368;

              .front-bar {
                height: 100%;
                background: white;
                position: relative;

                .ball {
                  width: 10px;
                  height: 10px;
                  background: white;
                  border-radius: 50%;
                  position: absolute;
                  right: -5px;
                  top: -5px;
                  transform: translateY(1px);
                }
              }
            }
          }

          .times {
            color: #f26166;
            margin-left: 5px;
          }
        }
      }
    }

    .cells-container {
      flex: 1;
      display: flex;
      overflow: auto;

      &::-webkit-scrollbar {
        background: #c23439;
        height: 6px;
      }

      &::-webkit-scrollbar-thumb {
        background: #ce5d61;
        border-radius: 20px;
      }

      .cell {
        width: @control-bar-width * 0.7;
        border-left: 1px solid #ce5d61;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 32px;
        flex-shrink: 0;
        color: #de4c51;
        cursor: pointer;
        overflow: hidden;
      }

      .cell-playing {
        background: #a8262a;
        img {
          width: 95%;
        }
      }
    }
  }
}

@keyframes floatMe {
  from {
    top: 23vh;
  }

  50% {
    top: 17vh;
  }

  to {
    top: 23vh;
  }
}

.tip-icon {
  position: fixed;
  left: 20vw;
  top: 40vh;
  width: 24vh;
  z-index: 999;

  animation: leftAndRight 2s infinite linear;
}

@keyframes leftAndRight {
  from {
    left: 20vw;
  }

  50% {
    left: 25vw;
  }

  to {
    left: 20vw;
  }
}
</style>